import React from 'react';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow, CheckIcon } from '@occc-app/design-system';
import { ProductGroupFragment } from '@occc/graphql';

import { ProductGroupActionsContainer } from './ProductGroupActionsContainer';

import { productGroupKeysMap } from '../../constants';
import { routeCreator } from '../../utils';

type ProductGroupTableRowProps = {
  productGroup: ProductGroupFragment;
  isUserPermittedToEditProductGroup: boolean;
  isUserPermittedToDeleteProductGroup: boolean;
};

export const ProductGroupTableRow = ({
  productGroup,
  isUserPermittedToEditProductGroup,
  isUserPermittedToDeleteProductGroup,
}: ProductGroupTableRowProps) => {
  const navigate = useNavigate();
  const onClick = () => navigate(routeCreator.details(productGroup.id));

  const areActionsVisible =
    isUserPermittedToEditProductGroup || isUserPermittedToDeleteProductGroup;

  const sortingRank = productGroup.fuelProductGroup?.userSelectable
    ? productGroup.fuelProductGroup.sortingRank
    : undefined;

  return (
    <TableRow key={productGroup.id} onClick={onClick}>
      <TableCell>{productGroup.name || 'No Name'}</TableCell>
      <TableCell>{productGroupKeysMap[productGroup.key]}</TableCell>
      <TableCell align='center'>{productGroup.values.length}</TableCell>
      <TableCell align='center'>
        {productGroup.fuelProductGroup?.userSelectable && <CheckIcon fontSize='small' />}
      </TableCell>
      <TableCell align='center'>{sortingRank}</TableCell>
      {areActionsVisible && (
        <TableCell padding='button' align='right'>
          <ProductGroupActionsContainer
            id={productGroup.id}
            name={productGroup.name || ''}
            isUserPermittedToEditProductGroup={isUserPermittedToEditProductGroup}
            isUserPermittedToDeleteProductGroup={isUserPermittedToDeleteProductGroup}
          />
        </TableCell>
      )}
    </TableRow>
  );
};
